import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../Contexts/UserContext";

const PrivateRoute = ({ children }) => {
  const user = useUser();
  const { CompCode } = user;
  let location = useLocation();

  if (user.isAuthenticated === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (CompCode === "1353") {
    return <Navigate to="/dashboardX" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
